module.exports = "/packs/images/svg/ireland/accessibility/disabled_toilets~e5caaa003b4d1b900cce008285b14fa8.svg";